export default __webpack_public_path__ + "static/media/bg-pattern-light.1ec5fd83.svg";